import { Ace as AceNamespace } from 'ace-builds';
import { AceEditorTheme } from 'modules/aceEditor';
import { FC, PropsWithChildren, useRef, useState } from 'react';
import { SideBySideEditorContext } from './SideBySideEditorContext';

type EditorContextProviderProps = {
  aceEditorTheme: AceEditorTheme;
};

export const EditorContextProvider: FC<PropsWithChildren<EditorContextProviderProps>> = ({
  children,
  aceEditorTheme,
}) => {
  const editor = useRef<AceNamespace.Editor | null>(null);
  /**
   * Global tracking of the selected img tag (used in both Creative Library and MovableInk)
   */
  const [selectedImage, setSelectedImage] = useState<HTMLImageElement>();
  /**
   * Global tracking of the selected a tag (used in MovableInk)
   */
  const [selectedAnchor, setSelectedAnchor] = useState<HTMLAnchorElement>();

  const undo = () => {
    const thisEditor = editor.current;
    if (thisEditor) {
      thisEditor.undo();
      thisEditor.focus();
    }
  };

  const redo = () => {
    const thisEditor = editor.current;
    if (thisEditor) {
      thisEditor.redo();
      thisEditor.focus();
    }
  };

  return (
    <SideBySideEditorContext.Provider
      value={{
        aceEditorTheme,
        editor,
        redo,
        selectedImage,
        selectedAnchor,
        setSelectedImage,
        setSelectedAnchor,
        undo,
      }}
    >
      {children}
    </SideBySideEditorContext.Provider>
  );
};
